module.exports = __webpack_public_path__ + "static/media/Batelco_.90290dad.jpg";